"use client";

import { useEffect, useState } from "react";
import Modal, { btnPrimary, btnGhost, btnDanger } from "@/components/finance/Modal";
import { registerDialogHost, type DialogRequest } from "./dialogs";

/** Mount once near the app root; renders notify()/confirmDialog() requests in the shared popup. */
export default function DialogHost() {
  const [queue, setQueue] = useState<DialogRequest[]>([]);

  useEffect(() => {
    registerDialogHost((req) => setQueue((q) => [...q, req]));
    return () => registerDialogHost(null);
  }, []);

  const current = queue[0];
  const close = (result: boolean) => {
    if (!current) return;
    if (current.kind === "confirm") current.resolve(result);
    else current.resolve();
    setQueue((q) => q.slice(1));
  };

  if (!current) return null;

  const title = current.title ?? (current.kind === "confirm" ? "Are you sure?" : current.tone === "error" ? "Something went wrong" : "Done");

  return (
    <Modal
      open
      zClass="z-[100010]"
      title={title}
      onClose={() => close(false)}
      footer={
        current.kind === "confirm" ? (
          <>
            <button className={btnGhost} onClick={() => close(false)}>Cancel</button>
            <button className={current.destructive ? btnDanger : btnPrimary} autoFocus onClick={() => close(true)}>{current.confirmLabel}</button>
          </>
        ) : (
          <button className={current.tone === "error" ? btnDanger : btnPrimary} autoFocus onClick={() => close(true)}>OK</button>
        )
      }
    >
      <p className={`text-sm whitespace-pre-line ${current.kind === "alert" && current.tone === "error" ? "text-red-700" : "text-gray-700"}`}>{current.message}</p>
    </Modal>
  );
}
